<template>
    <b-overlay :show="busy" rounded="sm">
        <b-card class="standardpage reports invoices border-none">
            <div class="availtable datatable">
                <b-card class="w-100pct">

                    <b-card-body class="py-0 px-0">

                        <b-tabs class="gridtabs" v-model="tabindex">

                            <b-tab>
                                <template #title>
                                    <i class="fa fa-wpforms text-info mr-1"></i>
                                    {{ item.ref }}
                                </template>

                                <table class="mt-3 mb-3 font-13px smallinputs" width="80%">
                                    <tr class="strong">
                                        <!-- <td width="40%">Contact</td> -->
                                        <td class="w-140px">Issue Date</td>
                                        <!-- <td class="w-110px">Due Date</td> -->
                                        <!-- <td>Your Ref / PO</td> -->
                                        <td class="w-100px">Ref</td>
                                    </tr>
                                    <tr>
                                        <!-- <td class="h6 strong">{{ item.address.name }}</td> -->
                                        <td>
                                            <!-- {{ $moment.unix(item.issued_at * 0.001).utc(false).format("DD-MMM-YY") }} -->
                                            <!-- <br> -->
                                            <b-form-group>
                                                <b-input-group>
                                                    <daterangepicker class="w-auto sm" size="sm" ref="mapper_issued_at"
                                                        v-model="mapper_issued_at" :opens="'right'" :locale-data="{
                                                            direction: 'ltr',
                                                            format: 'dd/mm/yy HH:MM',
                                                            daysOfWeek: [
                                                                'Sun',
                                                                'Mon',
                                                                'Tue',
                                                                'Wed',
                                                                'Thu',
                                                                'Fri',
                                                                'Sat',
                                                            ],
                                                            monthNames: [
                                                                'January',
                                                                'February',
                                                                'March',
                                                                'April',
                                                                'May',
                                                                'June',
                                                                'July',
                                                                'August',
                                                                'September',
                                                                'October',
                                                                'November',
                                                                'December',
                                                            ],
                                                            firstDay: 1,
                                                            applyLabel: 'OK',
                                                            cancelLabel: 'Cancel',
                                                        }" :ranges="false" :showDropdowns="true"
                                                        :single-date-picker="'single'" :timePicker="true"
                                                        :timePicker24Hour="true" :time-picker-increment="1">
                                                    </daterangepicker>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary" @click="mapper_issued_at = {
                                                            startDate: null,
                                                            endDate: null,
                                                        }
                                                            ">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </td>
                                        <!-- <td>                                      
                                            <b-form-group>
                                                <b-input-group>
                                                    <daterangepicker class="w-auto sm" size="sm" ref="mapper_due_at"
                                                        v-model="mapper_due_at" :opens="'right'" :locale-data="{
                                                            direction: 'ltr',
                                                            format: 'dd/mm/yy',
                                                            daysOfWeek: [
                                                                'Sun',
                                                                'Mon',
                                                                'Tue',
                                                                'Wed',
                                                                'Thu',
                                                                'Fri',
                                                                'Sat',
                                                            ],
                                                            monthNames: [
                                                                'January',
                                                                'February',
                                                                'March',
                                                                'April',
                                                                'May',
                                                                'June',
                                                                'July',
                                                                'August',
                                                                'September',
                                                                'October',
                                                                'November',
                                                                'December',
                                                            ],
                                                            firstDay: 1,
                                                            applyLabel: 'OK',
                                                            cancelLabel: 'Cancel',
                                                        }" :ranges="false" :showDropdowns="true"
                                                        :single-date-picker="'single'" :timePicker="false"
                                                        :timePicker24Hour="false" :time-picker-increment="1">
                                                    </daterangepicker>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary" @click="mapper_due_at = {
                                                            startDate: null,
                                                            endDate: null,
                                                        }
                                                            ">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </td> -->
                                        <!-- <td>
                                        
                                            <b-form-group>
                                                <b-input-group>
                                                    <b-form-input size="sm" v-model="item.yourref"
                                                        placeholder="Enter Your Ref/PO"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="item.yourref = 'Enter Your Ref/PO'">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </td> -->
                                        <td>
                                            <!-- {{ item.ref }}
                                            <br> -->
                                            <b-form-group>
                                                <b-input-group>
                                                    <b-form-input size="sm" v-model="item.ref"
                                                        placeholder="Enter Invoice Number"
                                                        disabled="true"></b-form-input>
                                                </b-input-group>
                                            </b-form-group>
                                        </td>
                                    </tr>
                                    <!-- <tr>
                                        <td>
                                            <div v-if="item.address.address_addressee">
                                                Addressee: {{ item.address.address_addressee }} <br /></div>
                                            <div v-if="item.address.address_line1">
                                                {{ item.address.address_line1 }} <br /></div>
                                            <div v-if="item.address.address_line2">
                                                {{ item.address.address_line2 }} <br /></div>
                                            <div v-if="item.address.address_city">
                                                {{ item.address.address_city }} <br /></div>
                                            <div v-if="item.address.address_county">
                                                {{ item.address.address_county }} <br /></div>
                                            <div v-if="item.address.address_postcode">
                                                {{ item.address.address_postcode }} <br /></div>
                                            <div v-if="item.address.address_country">
                                                {{ item.address.address_country }} <br /></div>
                                        </td>
                                        <td colspan="4">&nbsp;</td>
                                    </tr> -->
                                </table>

                                <b-row class="divider mx-0 mt-2"></b-row>
                                <p v-if="selection.length == 1">

                                    <b-row>
                                        <b-col>
                                            <d-table classdivtable="availtable datatable nested" refid="segments"
                                                :icon="sllines.icon" :busy="sllines.busy" :selectmode="'multi'"
                                                :selectall="sllines.selectall" :tools="sllines.tools"
                                                :badges="sllines.badges" :fields="sllines.fields" :items="sllines.items"
                                                :downloaded="sllines.downloaded" :page="sllines.page" :showpages="false"
                                                :showrowcount="false" @load="sllines_load" @click="sllines_click"
                                                @select="sllines_select">
                                            </d-table>
                                        </b-col>
                                    </b-row>

                                    <b-row class="my-0 justify-content-end font-normal" no-gutters>
                                        <b-col cols="12" sm="6" md="4">
                                            <table class="w-100pct">
                                                <tr>
                                                    <td class="py-2 strong font-2x">Total</td>
                                                    <td class="py-2 strong text-right font-2x"
                                                        :class="parseFloat(item.sum_amount) < 0 ? 'text-danger' : 'text-primary'">
                                                        {{
                                                            parseFloat(item.sum_amount).toLocaleString(undefined, {
                                                                minimumFractionDigits: 2
                                                            })
                                                        }}</td>
                                                </tr>
                                                <tr class="divider"></tr>
                                            </table>
                                        </b-col>
                                    </b-row>

                                    <b-tabs v-if="sllines.edit" class="gridtabs mt-2">
                                        <b-tab>
                                            <template #title>
                                                <span class="text-primary">{{sllines.items.map(o =>
                                                    o.line).indexOf(sllines.item.line) + 1
                                                    }}.</span>
                                                <i :class="'fa fa fa-arrows-h text-info'"
                                                    class="text-primary ml-1 mr-1"></i>
                                                <span class="text-warning">&lt;{{ selection.length == 0 ? "new"
                                                    : "line edit" }}&gt;</span>&nbsp;


                                            </template>

                                            <p class="py-0 px-0 ">
                                                <b-card class="nopadding mt-0 "><b-card-body>

                                                        <div class="px-0 mt-2">

                                                            <b-row>

                                                                <b-col cols="12" sm="4" md="3">
                                                                    <b-form-group label-cols="12" label="Date"
                                                                        label-size="sm">
                                                                        <b-input-group>
                                                                            <daterangepicker class="w-auto sm" size="sm"
                                                                                ref="issued_at"
                                                                                v-model="mapper_issued_at"
                                                                                :opens="'right'" :locale-data="{
                                                                                    direction: 'ltr',
                                                                                    format: 'dd/mm/yy',
                                                                                    daysOfWeek: [
                                                                                        'Sun',
                                                                                        'Mon',
                                                                                        'Tue',
                                                                                        'Wed',
                                                                                        'Thu',
                                                                                        'Fri',
                                                                                        'Sat',
                                                                                    ],
                                                                                    monthNames: [
                                                                                        'January',
                                                                                        'February',
                                                                                        'March',
                                                                                        'April',
                                                                                        'May',
                                                                                        'June',
                                                                                        'July',
                                                                                        'August',
                                                                                        'September',
                                                                                        'October',
                                                                                        'November',
                                                                                        'December',
                                                                                    ],
                                                                                    firstDay: 1,
                                                                                    applyLabel: 'OK',
                                                                                    cancelLabel: 'Cancel',
                                                                                }" :ranges="false"
                                                                                :showDropdowns="true"
                                                                                :single-date-picker="'single'"
                                                                                :timePicker="false"
                                                                                :timePicker24Hour="false"
                                                                                :time-picker-increment="1">
                                                                            </daterangepicker>
                                                                            <b-input-group-append>
                                                                                <b-button size="sm"
                                                                                    variant="outline-secondary" @click="mapper_issued_at = {
                                                                                        startDate: null,
                                                                                        endDate: null,
                                                                                    }
                                                                                        ">
                                                                                    <i class="fa fa-remove"></i>
                                                                                </b-button>
                                                                            </b-input-group-append>
                                                                        </b-input-group>
                                                                    </b-form-group>
                                                                </b-col>

                                                                <b-col cols="12" sm="6" md="4" xl="3">
                                                                    <b-form-group label-cols="12" label="Event"
                                                                        label-size="sm">
                                                                        <treeselect placeholder="Select event..."
                                                                            searchPromptText="Type at least 3 chars..."
                                                                            v-model="sllines.item.eventcode"
                                                                            :clearable="true" :async="true"
                                                                            :load-options="treeselect_loadEvent"
                                                                            :show-count="true"
                                                                            :flatten-search-results="true"
                                                                            :disable-branch-nodes="true"
                                                                            :matchKeys="['id']" search-nested
                                                                            :disabled="readonly">
                                                                            <div slot="value-label"
                                                                                slot-scope="{ node }">
                                                                                {{ node.raw.id }}
                                                                            </div>
                                                                        </treeselect>
                                                                    </b-form-group>
                                                                </b-col>

                                                                <b-col cols="12" sm="6" md="4" xl="3">
                                                                    <b-form-group label-cols="12" label="Client SL A/C"
                                                                        label-size="sm">
                                                                        <treeselect placeholder="Select slac..."
                                                                            searchPromptText="Type at least 3 chars..."
                                                                            v-model="sllines.item.slac"
                                                                            :clearable="true" :async="true"
                                                                            :load-options="treeselect_loadSLAC"
                                                                            :show-count="true"
                                                                            :flatten-search-results="true"
                                                                            :disable-branch-nodes="true"
                                                                            :matchKeys="['id']" search-nested
                                                                            :disabled="readonly">
                                                                            <div slot="value-label"
                                                                                slot-scope="{ node }">
                                                                                {{ node.raw.id }}
                                                                            </div>
                                                                        </treeselect>
                                                                    </b-form-group>
                                                                </b-col>

                                                                <b-col cols="12" sm="6" md="4" xl="3">
                                                                    <b-form-group label-cols="12"
                                                                        label="Supplier BL A/C" label-size="sm">
                                                                        <treeselect placeholder="Select blac..."
                                                                            searchPromptText="Type at least 3 chars..."
                                                                            v-model="sllines.item.blac"
                                                                            :clearable="true" :async="true"
                                                                            :load-options="treeselect_loadBLAC"
                                                                            :show-count="true"
                                                                            :flatten-search-results="true"
                                                                            :disable-branch-nodes="true"
                                                                            :matchKeys="['id']" search-nested
                                                                            :disabled="readonly">
                                                                            <div slot="value-label"
                                                                                slot-scope="{ node }">
                                                                                {{ node.raw.id }}
                                                                            </div>
                                                                        </treeselect>
                                                                    </b-form-group>
                                                                </b-col>

                                                                <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                                                    <b-form-group label-cols="12" label="Supplier Type"
                                                                        label-size="sm">
                                                                        <treeselect
                                                                            placeholder="Select supplier type..."
                                                                            searchPromptText="Supplier Type..."
                                                                            v-model="sllines.item.suptype"
                                                                            :clearable="true"
                                                                            :options="options_suppliertype">
                                                                        </treeselect>
                                                                    </b-form-group>
                                                                </b-col> -->

                                                                <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                                                    <b-form-group label="Your Ref/PO"
                                                                        label-for="yourref" label-cols="12">
                                                                        <b-input-group>
                                                                            <b-form-input type="text"
                                                                                :debounce="sllines.debounce"
                                                                                v-model="sllines.item.yourref"
                                                                                placeholder="Your Ref/PO" size="sm" trim
                                                                                :disabled="readonly"></b-form-input>
                                                                            <b-input-group-append>
                                                                                <b-button size="sm"
                                                                                    variant="outline-secondary"
                                                                                    @click="sllines.item.yourref = ''"
                                                                                    :disabled="readonly">
                                                                                    <i class="fa fa-remove"></i>
                                                                                </b-button>
                                                                            </b-input-group-append>
                                                                        </b-input-group>
                                                                    </b-form-group>
                                                                </b-col> -->

                                                                <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                                                    <b-form-group label="Qty" label-for="qty"
                                                                        label-cols="12">
                                                                        <b-input-group>
                                                                            <b-form-input type="number"
                                                                                :debounce="sllines.debounce"
                                                                                :min="min_qty" :max="max_qty"
                                                                                v-model="sllines.item.qty"
                                                                                placeholder="Qty" size="sm" trim
                                                                                :disabled="readonly"></b-form-input>
                                                                            <b-input-group-append>
                                                                                <b-button size="sm"
                                                                                    variant="outline-secondary"
                                                                                    @click="sllines.item.qty = '0'"
                                                                                    :disabled="readonly">
                                                                                    <i class="fa fa-remove"></i>
                                                                                </b-button>
                                                                            </b-input-group-append>
                                                                        </b-input-group>
                                                                    </b-form-group>
                                                                </b-col> -->

                                                                <b-col cols="12" sm="6" md="4" xl="3">
                                                                    <b-form-group label="Amount" label-for="amount"
                                                                        label-cols="12">
                                                                        <b-input-group>
                                                                            <b-form-input type="text"
                                                                                :debounce="sllines.debounce"
                                                                                v-model="sllines.item.amount"
                                                                                placeholder="Amount" size="sm" trim
                                                                                :disabled="readonly"></b-form-input>
                                                                            <b-input-group-append>
                                                                                <b-button size="sm"
                                                                                    variant="outline-secondary"
                                                                                    @click="sllines.item.amount = '0.00'"
                                                                                    :disabled="readonly">
                                                                                    <i class="fa fa-remove"></i>
                                                                                </b-button>
                                                                            </b-input-group-append>
                                                                        </b-input-group>
                                                                    </b-form-group>
                                                                </b-col>
                                                                <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                                                    <b-form-group label="Taxes" label-for="line_taxes"
                                                                        label-cols="12">
                                                                        <b-input-group>
                                                                            <b-form-input type="text"
                                                                                :debounce="sllines.debounce"
                                                                                v-model="sllines.item.line_taxes"
                                                                                placeholder="Taxes" size="sm" trim
                                                                                :disabled="readonly"></b-form-input>
                                                                            <b-input-group-append>
                                                                                <b-button size="sm"
                                                                                    variant="outline-secondary"
                                                                                    @click="sllines.item.line_taxes = '0.00'"
                                                                                    :disabled="readonly">
                                                                                    <i class="fa fa-remove"></i>
                                                                                </b-button>
                                                                            </b-input-group-append>
                                                                        </b-input-group>
                                                                    </b-form-group>
                                                                </b-col> -->

                                                                <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                                                    <b-form-group label="Fees" label-for="line_fees"
                                                                        label-cols="12">
                                                                        <b-input-group>
                                                                            <b-form-input type="text"
                                                                                :debounce="sllines.debounce"
                                                                                v-model="sllines.item.line_fees"
                                                                                placeholder="Fees" size="sm" trim
                                                                                :disabled="readonly"></b-form-input>
                                                                            <b-input-group-append>
                                                                                <b-button size="sm"
                                                                                    variant="outline-secondary"
                                                                                    @click="sllines.item.line_fees = '0.00'"
                                                                                    :disabled="readonly">
                                                                                    <i class="fa fa-remove"></i>
                                                                                </b-button>
                                                                            </b-input-group-append>
                                                                        </b-input-group>
                                                                    </b-form-group>
                                                                </b-col> -->

                                                                <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                                                    <b-form-group label="VAT" label-for="line_vat"
                                                                        label-cols="12">
                                                                        <b-input-group>
                                                                            <b-form-input type="text"
                                                                                :debounce="sllines.debounce"
                                                                                v-model="sllines.item.line_vat"
                                                                                placeholder="VAT" size="sm" trim
                                                                                :disabled="readonly"></b-form-input>
                                                                            <b-input-group-append>
                                                                                <b-button size="sm"
                                                                                    variant="outline-secondary"
                                                                                    @click="sllines.item.line_vat = '0.00'"
                                                                                    :disabled="readonly">
                                                                                    <i class="fa fa-remove"></i>
                                                                                </b-button>
                                                                            </b-input-group-append>
                                                                        </b-input-group>
                                                                    </b-form-group>
                                                                </b-col> -->

                                                                <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                                                    <b-form-group label="Due" label-for="line_due"
                                                                        label-cols="12">
                                                                        <b-input-group>
                                                                            <b-form-input type="text"
                                                                                :debounce="sllines.debounce"
                                                                                v-model="sllines.item.line_due"
                                                                                placeholder="Due" size="sm" trim
                                                                                :disabled="true"></b-form-input>
                                                                            <b-input-group-append>
                                                                                <b-button size="sm"
                                                                                    variant="outline-secondary"
                                                                                    @click="sllines.item.line_due = '0.00'"
                                                                                    :disabled="true">
                                                                                    <i class="fa fa-remove"></i>
                                                                                </b-button>
                                                                            </b-input-group-append>
                                                                        </b-input-group>
                                                                    </b-form-group>
                                                                </b-col> -->

                                                                <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                                                    <b-form-group label="Amount" label-for="line_exvat"
                                                                        label-cols="12">
                                                                        <b-input-group>
                                                                            <b-form-input type="text"
                                                                                :debounce="sllines.debounce"
                                                                                v-model="sllines.item.line_exvat"
                                                                                placeholder="Amount" size="sm" trim
                                                                                :disabled="true"></b-form-input>
                                                                            <b-input-group-append>
                                                                                <b-button size="sm"
                                                                                    variant="outline-secondary"
                                                                                    @click="sllines.item.line_exvat = '0.00'"
                                                                                    :disabled="true">
                                                                                    <i class="fa fa-remove"></i>
                                                                                </b-button>
                                                                            </b-input-group-append>
                                                                        </b-input-group>
                                                                    </b-form-group>
                                                                </b-col> -->

                                                                <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                                                    <b-form-group label="Unit Total"
                                                                        label-for="line_total" label-cols="12">
                                                                        <b-input-group>
                                                                            <b-form-input type="text"
                                                                                :debounce="sllines.debounce"
                                                                                v-model="sllines.item.line_total"
                                                                                placeholder="Unit Total" size="sm" trim
                                                                                :disabled="true"></b-form-input>
                                                                            <b-input-group-append>
                                                                                <b-button size="sm"
                                                                                    variant="outline-secondary"
                                                                                    @click="sllines.item.line_total = ''"
                                                                                    :disabled="true">
                                                                                    <i class="fa fa-remove"></i>
                                                                                </b-button>
                                                                            </b-input-group-append>
                                                                        </b-input-group>
                                                                    </b-form-group>
                                                                </b-col> -->

                                                                <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                                                            <b-form-group label="Supplier Type"
                                                                                label-for="type" label-cols="12">
                                                                                <b-input-group>
                                                                                    <b-form-input type="text"
                                                                                        v-model="sllines.item.bltype"
                                                                                        placeholder="Supplier Type"
                                                                                        size="sm"
                                                                                        :disabled="false"></b-form-input>
                                                                                    <b-input-group-append>
                                                                                        <b-button size="sm"
                                                                                            :disabled="false"
                                                                                            variant="outline-secondary"
                                                                                            @click="sllines.item.bltype = ''">
                                                                                            <i class="fa fa-remove"></i>
                                                                                        </b-button>
                                                                                    </b-input-group-append>
                                                                                </b-input-group>
                                                                            </b-form-group>
                                                                        </b-col> -->
                                                                <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                                                            <b-form-group
                                                                                label="Conferma Transaction ID"
                                                                                label-for="confermatransactionid"
                                                                                label-cols="12">
                                                                                <b-input-group>
                                                                                    <b-form-input type="text"
                                                                                        v-model="sllines.item.confermatransactionid"
                                                                                        placeholder="Conferma Transaction ID"
                                                                                        size="sm"
                                                                                        :disabled="true"></b-form-input>
                                                                                    <b-input-group-append>
                                                                                        <b-button size="sm"
                                                                                            :disabled="true"
                                                                                            variant="outline-secondary"
                                                                                            @click="sllines.item.confermatransactionid = ''">
                                                                                            <i class="fa fa-remove"></i>
                                                                                        </b-button>
                                                                                    </b-input-group-append>
                                                                                </b-input-group>
                                                                            </b-form-group>
                                                                        </b-col> -->
                                                                <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                                                            <b-form-group label="Conferma Deployment ID"
                                                                                label-for="confermadeploymentid"
                                                                                label-cols="12">
                                                                                <b-input-group>
                                                                                    <b-form-input type="text"
                                                                                        v-model="sllines.item.confermadeploymentid"
                                                                                        placeholder="Conferma Deployment ID"
                                                                                        size="sm"
                                                                                        :disabled="true"></b-form-input>
                                                                                    <b-input-group-append>
                                                                                        <b-button size="sm"
                                                                                            :disabled="true"
                                                                                            variant="outline-secondary"
                                                                                            @click="sllines.item.confermadeploymentid = ''">
                                                                                            <i class="fa fa-remove"></i>
                                                                                        </b-button>
                                                                                    </b-input-group-append>
                                                                                </b-input-group>
                                                                            </b-form-group>
                                                                        </b-col> -->
                                                            </b-row>

                                                            <!-- <b-row>
                                                                <b-col cols="6">
                                                                    <b-form-group label="Details" label-for="detail"
                                                                        label-cols="12">
                                                                        <b-input-group>
                                                                            <b-form-input type="text"
                                                                                :debounce="sllines.debounce"
                                                                                v-model="sllines.item.description"
                                                                                placeholder="Details" size="sm"
                                                                                :disabled="readonly"></b-form-input>
                                                                            <b-input-group-append>
                                                                                <b-button size="sm" :disabled="readonly"
                                                                                    variant="outline-secondary"
                                                                                    @click="sllines.item.description = ''">
                                                                                    <i class="fa fa-remove"></i>
                                                                                </b-button>
                                                                            </b-input-group-append>
                                                                        </b-input-group>
                                                                    </b-form-group>
                                                                </b-col>
                                                                <b-col cols="6">
                                                                    <b-form-group label="Remark-CHECK"
                                                                        label-for="remark" label-cols="12">
                                                                        <b-input-group>
                                                                            <b-form-input type="text"
                                                                                :debounce="sllines.debounce"
                                                                                v-model="sllines.item.remark"
                                                                                placeholder="Remark" size="sm" trim
                                                                                :disabled="readonly"></b-form-input>
                                                                            <b-input-group-append>
                                                                                <b-button size="sm"
                                                                                    variant="outline-secondary"
                                                                                    @click="sllines.item.remark = ''"
                                                                                    :disabled="readonly">
                                                                                    <i class="fa fa-remove"></i>
                                                                                </b-button>
                                                                            </b-input-group-append>
                                                                        </b-input-group>
                                                                    </b-form-group>
                                                                </b-col>
                                                            </b-row> -->

                                                        </div>
                                                    </b-card-body>

                                                </b-card>
                                            </p>
                                        </b-tab>


                                        <b-tab v-if="sllines.item.id">
                                            <template #title>
                                                <i class="fa fa-history text-primary mr-1"></i>Audit
                                            </template>
                                            <p class="py-3 px-0">
                                                <b-row>
                                                    <b-col cols="12" sm="6" md="4" xl="3">
                                                        <b-form-group label="ID" label-for="id" label-cols="12">
                                                            <b-input-group>
                                                                <b-form-input type="text" v-model="sllines.item.id"
                                                                    placeholder="" size="sm"
                                                                    :disabled="true"></b-form-input>

                                                            </b-input-group>
                                                        </b-form-group>
                                                    </b-col>

                                                </b-row>

                                                <b-row>
                                                    <b-col cols="12" sm="6" md="4" xl="3">
                                                        <b-form-group label="Created At" label-for="created_at"
                                                            label-cols="12">
                                                            <b-input-group>
                                                                <b-input-group-prepend>
                                                                    <b-form-datepicker size="sm"
                                                                        v-model="sllines.item.created_at" button-only
                                                                        label-help="" locale="en-GB"
                                                                        :disabled="true"></b-form-datepicker>
                                                                </b-input-group-prepend>
                                                                <b-form-input size="sm" id="date"
                                                                    v-model="sllines.item.created_at" type="text"
                                                                    placeholder="YYYY-MM-DD" autocomplete="off"
                                                                    :disabled="true"></b-form-input>
                                                                <b-input-group-append>
                                                                    <b-button size="sm" variant="outline-secondary"
                                                                        @click="sllines.item.created_at = null"
                                                                        :disabled="true">
                                                                        <i class="fa fa-remove"></i>
                                                                    </b-button>
                                                                </b-input-group-append>
                                                            </b-input-group>
                                                        </b-form-group>
                                                    </b-col>

                                                    <b-col cols="12" sm="6" md="4" xl="3">
                                                        <b-form-group label="Created By" label-for="created_by"
                                                            label-cols="12">
                                                            <b-input-group>
                                                                <b-form-input type="text"
                                                                    v-model="sllines.item.created_by" placeholder=""
                                                                    size="sm" :disabled="true"></b-form-input>
                                                                <b-input-group-append>
                                                                    <b-button size="sm" variant="outline-secondary"
                                                                        @click="sllines.item.created_by = ''"
                                                                        :disabled="true">
                                                                        <i class="fa fa-remove"></i>
                                                                    </b-button>
                                                                </b-input-group-append>
                                                            </b-input-group>
                                                        </b-form-group>
                                                    </b-col>

                                                    <b-col cols="12" sm="6" md="4" xl="3">
                                                        <b-form-group label="Updated At" label-for="updated_at"
                                                            label-cols="12">
                                                            <b-input-group>
                                                                <b-input-group-prepend>
                                                                    <b-form-datepicker size="sm"
                                                                        v-model="sllines.item.updated_at" button-only
                                                                        label-help="" locale="en-GB"
                                                                        :disabled="true"></b-form-datepicker>
                                                                </b-input-group-prepend>
                                                                <b-form-input size="sm" id="date"
                                                                    v-model="sllines.item.updated_at" type="text"
                                                                    placeholder="YYYY-MM-DD" autocomplete="off"
                                                                    :disabled="true"></b-form-input>
                                                                <b-input-group-append>
                                                                    <b-button size="sm" variant="outline-secondary"
                                                                        @click="sllines.item.updated_at = null"
                                                                        :disabled="true">
                                                                        <i class="fa fa-remove"></i>
                                                                    </b-button>
                                                                </b-input-group-append>
                                                            </b-input-group>
                                                        </b-form-group>
                                                    </b-col>

                                                    <b-col cols="12" sm="6" md="4" xl="3">
                                                        <b-form-group label="Updated By" label-for="updated_by"
                                                            label-cols="12">
                                                            <b-input-group>
                                                                <b-form-input type="text"
                                                                    v-model="sllines.item.updated_by" placeholder=""
                                                                    size="sm" :disabled="true"></b-form-input>
                                                                <b-input-group-append>
                                                                    <b-button size="sm" variant="outline-secondary"
                                                                        @click="sllines.item.updated_by = ''"
                                                                        :disabled="true">
                                                                        <i class="fa fa-remove"></i>
                                                                    </b-button>
                                                                </b-input-group-append>
                                                            </b-input-group>
                                                        </b-form-group>
                                                    </b-col>
                                                </b-row>

                                            </p>
                                        </b-tab>
                                    </b-tabs>

                                    <b-alert :show="changed" :variant="'primary'" class="text-center mt-2 mb-1">
                                        <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                                <i class="fa fa-info-circle fa-2x"></i></b-col>
                                            <b-col> <span
                                                    v-html="'Changes have been made - click \'Post It\' to save changes'"></span></b-col></b-row>
                                    </b-alert>

                                    <b-alert :show="locked" :variant="'danger'" class="text-center mt-2 mb-1">
                                        <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                                <i class="fa fa-info-circle fa-2x"></i></b-col>
                                            <b-col> <span
                                                    v-html="'Changes not permitted on this record - allocated to another entry'"></span></b-col></b-row>
                                    </b-alert>
                                </p>
                            </b-tab>

                            <b-tab>
                                <template #title>
                                    <i class="fa fa-comments-o text-primary mr-1"></i>
                                    Notes</template>
                                <p class="py-3 px-0">
                                    <b-row>
                                        <b-col cols="12">
                                            <b-form-group label="Notes" label-for="comments" label-cols="12">
                                                <b-form-textarea id="data" v-model="item.comments" placeholder="Notes"
                                                    rows="6" class="smalltextarea"></b-form-textarea>
                                            </b-form-group> </b-col></b-row>
                                    <b-row class="mt-1">
                                        <b-col>
                                            <b-button squared size="sm" variant="outline-primary" class="mr-1"
                                                @click="timestamp">
                                                <i class="fa fa-clock-o"></i>
                                                Add a timestamp
                                            </b-button>
                                        </b-col>
                                    </b-row>
                                </p>
                            </b-tab>

                            <b-tab>
                                <template #title>
                                    <i class="fa fa-history text-primary mr-1"></i>Audit
                                </template>

                                <p v-if="idselected" class="py-3 px-0">
                                    <b-row>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="ID" label-for="id" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="item.id" placeholder="" size="sm"
                                                        :disabled="true"></b-form-input>

                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                    </b-row>

                                    <b-row>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Created At" label-for="created_at" label-cols="12">
                                                <b-input-group>
                                                    <b-input-group-prepend>
                                                        <b-form-datepicker size="sm" v-model="item.created_at"
                                                            button-only label-help="" locale="en-GB"
                                                            :disabled="true"></b-form-datepicker>
                                                    </b-input-group-prepend>
                                                    <b-form-input size="sm" id="date" v-model="item.created_at"
                                                        type="text" placeholder="YYYY-MM-DD" autocomplete="off"
                                                        :disabled="true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="item.created_at = null" :disabled="true">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Created By" label-for="created_by" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="item.created_by" placeholder=""
                                                        size="sm" :disabled="true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="item.created_by = ''" :disabled="true">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Updated At" label-for="updated_at" label-cols="12">
                                                <b-input-group>
                                                    <b-input-group-prepend>
                                                        <b-form-datepicker size="sm" v-model="item.updated_at"
                                                            button-only label-help="" locale="en-GB"
                                                            :disabled="true"></b-form-datepicker>
                                                    </b-input-group-prepend>
                                                    <b-form-input size="sm" id="date" v-model="item.updated_at"
                                                        type="text" placeholder="YYYY-MM-DD" autocomplete="off"
                                                        :disabled="true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="item.updated_at = null" :disabled="true">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Updated By" label-for="updated_by" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="item.updated_by" placeholder=""
                                                        size="sm" :disabled="true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="item.updated_by = ''" :disabled="true">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </p>
                            </b-tab>
                            <!-- <b-tab v-if="selection.length == 1">
                                <template #title>
                                    <i class="fa fa-wpforms text-info mr-1"></i>Invoice
                                </template>
                                <div class="etr">
                                    <b-row>
                                        <b-col cols="12">
                                            <r-invoice :ref="item.ref" />
                                        </b-col>
                                    </b-row>
                                </div>
                            </b-tab> -->

                        </b-tabs>

                    </b-card-body>

                    <b-card-footer class="nopadding mt-2">
                        <b-row no-gutters>
                            <b-col cols="auto" class="text-left">
                                <b-button squared size="sm" variant="primary" @click="postit()"
                                    v-if="user.permissions.includes('nominalledger.save')" :disabled="postit_disabled">
                                    <i class="fa fa-check"></i>
                                    Post It
                                </b-button>
                            </b-col>
                            <b-col class="text-left ml-2 mt-1">
                                <div v-if="busy">
                                    <i class="fa fa-spinner fa-spin text-primary"></i>
                                </div>
                                <div v-else>
                                    <span v-html="message"></span>
                                </div>
                            </b-col>
                            <b-col class="text-right" cols="8">
                                <b-button squared size="sm" variant="secondary" @click="$emit('discard')">
                                    <i class="fa fa-chevron-left pr-1"></i>
                                    Back
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-card-footer>
                </b-card>
            </div>
        </b-card>
    </b-overlay>
</template>

<script>
import gql from "graphql-tag";

export default {
    name: "NLItemEditN",
    async mounted() {
        this.item.agent = this.user.initials;
        // try {
        //     const response = await this.$apollo.query({
        //         query: gql`
        //             query suppliertypes {
        //                 suppliertypes {
        //                     id
        //                     label
        //                 }
        //             }
        //             `,
        //     });
        //     this.options_suppliertype = response.data.suppliertypes;
        // } catch (error) {
        // }
        await this.sllines_load(0);
    },
    data() {
        return {
            busy: false,
            tabindex: 0,
            showHeader: false,
            showTags: false,
            mapper_issued_at: {
                startDate: this.$moment().format("YYYY-MM-DD HH:mm"),
                endDate: this.$moment().format("YYYY-MM-DD HH:mm"),
            },

            message: "",
            amount: "0.00",
            load_busy: false,

            item: {
                ref: "*new",
                //  prefix: "IM",
                type: "",
                issued_at: this.$moment().valueOf().toString(),
                slac: null,
                 blac: null,
                  nlac: null,
                agent: null,
                //ticketno: null,
                amount: "0.00",
               // items: [{ id: "", name: "Passenger 1", ticketno: "abc" }],
                items: [{ id: ""}],
            },
            sllines: {
                title: "Item Lines",
                icon: "fa fa-list text-info",
                debounce: 1000,
                busy: false,
                selectall: false,
                edit: false,
                // clone,
                tools: "go,download,clipboard,edit,deleteconfirm",
                fields: [
                    {
                        key: "selected",
                        label: "...",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-right w-50px",
                    },
                    {
                        key: "line",
                        label: "Line",
                        sortable: true,
                    },
                    {
                        key: "issued_at",
                        label: "DateTravel",
                        sortable: true,
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = this.$moment.unix(value * .001).utc(true).format("DD/MM/YYYY");
                            }
                            return result;
                        },
                    },
                    {
                        key: "ledger",
                        label: "Type",
                        sortable: true,
                    },
                    {
                        key: "nlac",
                        label: "NL A/C",
                        sortable: true,
                        class: "d-none d-sm-table-cell",
                    },
                    {
                        key: "type",
                        label: "Trans",
                        sortable: true,
                        class: "text-right",
                    },
                    {
                        key: "ref",
                        label: "Ref",
                        sortable: true,
                        class: "text-right",
                    },

                    {
                        key: "blac",
                        label: "BL A/C",
                        sortable: true,
                        class: "text-right",
                    },
                    {
                        key: "slac",
                        label: "SL A/C",
                        sortable: true,
                        class: "d-none d-sm-table-cell",
                    },

                    {
                        key: "eventcode",
                        label: "Event",
                        sortable: true,
                        class: "text-right",
                    },
                    {
                        key: "amount",
                        label: "Amount",
                        sortable: true,
                        class: "text-right",
                        total: 0,
                        totalled: true,
                    },
                    {
                        key: "period",
                        label: "Period",
                        sortable: true,
                        class: "text-right",
                    },
                    {
                        key: "age",
                        label: "Age",
                        sortable: true,
                        class: "text-right",
                    },
                    {
                        key: "updated_by",
                        label: "Updated By",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "updated_at",
                        label: "Updated At",
                        sortable: true,
                    },



                ],
                badges: [
                    // {
                    //     key: "suptype",
                    //     type: "pill",
                    //     class: "secondary",
                    // },
                ],
                item: {},
                items: [],
                selected: [],
                downloaded: []
            },

            // mapper_ticketno_input: false,
            // mapper_ticketno: [],
            // mapper_datetravel: []
        };
    },
    computed: {
        readonly() {
            if (this.user.initials == 'MR') {
                return false;
            }
            if (this.selection.length == 0) {
                return false;
            }
            if (this.user.permissions.includes('nominalledger.admin')) {
                return false;
            }
            if (this.user.permissions.includes('nominalledger.save') && this.item.age == 0) {
                return false
            }
            if (this.locked) {
                return true
            }
            return true;
        },
        readonly_formula() {
            if (this.selection.length == 0) {
                return false;
            }
            return true;
        },
        postit_disabled() {

            if (this.user.initials == 'MR') {
                return false;
            }
            return this.locked
        },
        min_qty() {
            if (this.sllines.item) {
                if (this.sllines.item.qty <= 0) {
                    return 1000 * Math.sign(this.sllines.item.qty)
                } else {
                    return 1 * Math.sign(this.sllines.item.qty)
                }
            } else {
                return 0
            }
        },
        max_qty() {
            if (this.sllines.item) {
                if (this.sllines.item.qty <= 0) {
                    return 1 * Math.sign(this.sllines.item.qty)
                } else {
                    return 1000 * Math.sign(this.sllines.item.qty)
                }
            } else {
                return 0
            }
        }
    },
    watch: {
        tabindex: {
            async handler(newVal, oldVal) {
                // if (newVal == 4) {
                //     this.item.ref = ""
                //     await this.load()
                // }
                // if (newVal == 1 || newVal == 2) {
                //     this.sllines.selected = []
                //     this.sllines.selectall = false
                //     this.sllines.edit = false
                // }
            }
        },
        mapper_issued_at: {
            async handler(newVal, oldVal) {
                if (newVal) {
                    this.item.mapper_issued_at = this.$moment(newVal.startDate).valueOf().toString()
                }
            }
        },

        // DATA MAPPERS TO UI CONTROLS
        // "sllines.item.ticketno": {
        //     async handler(newVal, oldVal) {
        //         if (newVal) {
        //             this.mapper_ticketno = this.sllines.item.ticketno.split(",")
        //         }
        //     }
        // },
        // mapper_ticketno: {
        //     async handler(newVal, oldVal) {
        //         if (newVal) {
        //             this.sllines.item.ticketno = newVal.join(",")
        //         }
        //     }
        // },

        "item.slac": {
            // deep: true,
            // immediate: true,
            async handler(newVal, oldVal) {
                console.log("watch:item.slac", newVal);
                let attributes = await this.$helpers.loadSLACAttributes(newVal);
                await this.load_mifields("true");
            },
        },
    },
    methods: {
        accessdenied() {
            this.bltransactions.denied = [];
            if (!this.user.permissions.includes("nominalledger.delete")) {
                this.bltransactions.denied.push("deleteconfirm");
            }
            if (!this.user.permissions.includes("nominalledger.save")) {
                this.bltransactions.denied.push("edit");
                //this.bltransactions.denied.push("credit");
                this.bltransactions.denied.push("save");
            }
            if (!this.user.permissions.includes("systems.development")) {
                // this.bltransactions.denied.push("adjustment");
            }
        },


        async sllines_load(offset, limit, page) {

            let state = this.sllines;

            if (page) {
                state.page = page
            }

            this.sllines.busy = true;
            this.sllines.items = [];

            // let requirements = "";
            // for (var prop in this.requirement) {
            //     if (prop.slice(0, 3) != 'mi_') {
            //         if (rows[0][prop] == null) {
            //             requirements += this.requirement[prop] + ",";
            //             break;
            //         }
            //     }
            // }
            // requirements += await this.mifields_requirement()

            // // console.log("requirements", requirements);
            // if (requirements.length > 0) {
            //     this.message =
            //         "<span class='text-danger'>" +
            //         requirements.slice(0, -1) +
            //         " required field(s). </span>";
            //     this.busy = false;
            //     return;
            // } else {
            //     this.message = ""
            // }

            // if (this.mifields.length > 0) {
            //     let tags = JSON.parse(this.item.tags || "{}");
            //     for (var k = 0; k < this.mifields.length; k++) {
            //         tags[this.mifields[k].key] = this.mifields[k].value;
            //     }
            //     rows[0].tags = JSON.stringify(tags);
            // }

            let variables = {
                ref: this.selection[0].id,
                query: "lines",
            };
            console.log("variables", variables);

            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query ledgersNL($ref: String, $query: String) {
                            ledgersNL(ref: $ref, query: $query) {
                            id
                            issued_at                           
                            ref
                            #yourref                           
                            line
                            slac
                            blac
                            nlac
                            # address {
                            #     name
                            #     address_addressee
                            #     address_line1
                            #     address_line2
                            #     address_city
                            #     address_county
                            #     address_postcode
                            #     address_country
                            # }
                            eventcode
                            #travel_at
                            #ticketno
                            #passenger
                            #routing
                           # agent
                            #qty                            
                            amount
                            sum_amount
                            type  
                            age
                            ap
                            lines
                            doctype
                            period
                            #comments
                            updated_at
                            updated_by
                            created_at
                            created_by
                            }
                        }
                    `,
                    variables,
                    fetchPolicy: "no-cache",
                });

                // this.locked = response.data.BLTransactions[0].locked

                this.item = response.data.ledgersNL[0]

                let startDate = null
                let endDate = null

                startDate = this.$moment.unix(this.item.issued_at * 0.001).utc(true).format("YYYY-MM-DD HH:mm")
                endDate = startDate
                this.mapper_issued_at = { startDate, endDate }

                this.sllines.items = response.data.ledgersNL

                // this.due = this.item.outstanding
                // this.sumsaletotal()

                this.changed = false

                state.downloaded = []
                if (limit == 0) {
                    state.downloaded = response.data.ledgersNL
                } else {
                    state.items = response.data.ledgersNL;
                }

            } catch (error) {
                console.log(error);
            }


            this.showHeader = false
            this.sllines.busy = false;
        },
        async sllines_click(a, ss) {
            console.log("lines_click", a, ss);

            let state = this.sllines;

            switch (a) {

                case "selectall":
                    state.selectall = !state.selectall
                    break;

                case "download_view":
                    state.downloaded = []
                    state.downloaded = this.state.items
                    break;

                case "download_all":
                    state.downloaded = []
                    await this.sllines_load(0, 0);
                    break;


                case "go":
                    this.component = null;
                    await this.sllines_load();
                    break;

                case "clone":
                    if (state.item) {
                        let copy = { ...state.item, id: "__copy", line: (this.sllines.items.length + 1).toString() }
                        delete copy.ticketno
                        // copy.travel_at = this.$moment(copy.travel_at).valueOf()
                        this.sllines.items.push(copy)
                    }
                    break;

                case "delete":
                    await this.lines_delete([state.item])
                    break;

                case "markup_amount":
                    for (var j = 0; j < this.sllines.selected.length; j++) {
                        this.sllines.selected[j].amount = (parseFloat(this.markup_amount)).toFixed(2)
                    }
                    this.amount()
                    break;

                case "edit":
                    state.edit = !state.edit
                    break;

                case "save":
                    await this.lines_saveit()
                    break;

            }
        },
        async sllines_select(ss, tools) {
            console.log("sllines_select", ss);

            let state = this.sllines;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = ["back", "go", "filter", "add", "download", "clipboard"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1
                // "clone",
                enabled = ["edit", "notes"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1
                enabled = ["save", "deleteconfirm"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }

            if (state.selected.length > 0) {
                state.item = state.selected[0]  // WHAT YOU SELECTED

                if (state.item.issued_at) {
                    let startDate = this.$moment.unix(state.item.issued_at * 0.001).utc(true).format("YYYY-MM-DD")
                    let endDate = startDate
                    this.issued_at = { startDate, endDate }
                }

            } else {
                state.item = {}
            }
        },

        async sllines_save(ss) {
            this.sllines.busy = true;

            let variables = {
                rows: this.cleanit(ss),
            };

            try {
                const response = await this.$apollo.mutate({
                    // mutation: gql`
                    // mutation BL_lineitems_save($rows: [BLTransactionitem_input]) {
                    //     BL_lineitems_save(rows: $rows) {
                    //         id
                    //     }
                    // }
                    // `,
                    // variables,
                });

                this.message = "<span class='text-primary'>Saved it.</span>";
                this.sllines.busy = false;

            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            await this.sllines_load()
        },
        async sllines_delete(ss) {
            this.sllines.busy = true;

            let variables = {
                rows: [{ id: this.sllines.item.iduid }],
            };

            try {
                const response = await this.$apollo.mutate({
                    // mutation: gql`
                    // mutation BL_lineitems_delete($rows: [BLTransactionitem_input]) {
                    //     BL_lineitems_delete(rows: $rows) {
                    //         id
                    //     }
                    // }
                    // `,
                    // variables,
                });

                this.message = "<span class='text-primary'>Deleted it.</span>";
                this.sllines.busy = true;

            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            await this.sllines_load()
        },

        async deleteit(s) {
            console.log("deleteit", s);

            let rows = [];
            s.forEach(function (v) {
                rows.push({ id: v.id });
            });

            let variables = {
                rows,
            };

            console.log(variables);
            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                    mutation ledgersNL_delete($rows: [ledgersNL_input]) {
                    ledgersNL_delete(rows: $rows) {
                        id
                    }
                    }
                    `,
                    variables,
                });
            } catch (error) {
                console.log(error);
            }

            await this.sltransactions_load();
        },
        async saveit() {
            this.busy = true;

            console.log(this.item.tags)
            let ss = this.selection

            let rows = []
            for (var i = 0; i < ss.length; ++i) {
                rows.push({
                    // entry: ss[i].entry,
                    // refcredit: this.item.refcredit ? this.item.refcredit : "",
                    // agent: this.item.agent,
                    //yourrefbn: this.item.yourrefbn ? this.item.yourrefbn : "",
                    slac: this.item.slac,
                    blac: this.item.blac,
                    nlac: this.item.nlac,
                    eventcode: this.item.eventcode,
                    //analysis1: this.item.analysis1,
                    //analysis2: this.item.analysis2,                    
                    comments: this.item.comments,
                    items: this.sllines.items
                })
            }

            let variables = {
                rows,
            };
            console.log("variables", variables);

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                    mutation ledgersNL_save($rows: [ledgersNL_input]) {
                        ledgersNL_save(rows: $rows) {
                        id
                        }
                    }
                    `,
                    variables,
                });

                // await this.load()
                this.message = "<span class='text-primary'>Saved it.</span>";

            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            this.busy = false;
            // await this.sllines_load();
        },

        async postit() {

            await this.saveit()

        },

        // sumsaletotal() {

        //     this.amount = 0
        //     if (this.sllines.items) {
        //         for (var j = 0; j < this.sllines.items.length; j++) {


        //             if (isNaN(this.sllines.items[j].lineprice)) { this.sllines.items[j].lineprice = "0" }
        //             this.sllines.items[j].lineprice = parseFloat(Math.abs(this.sllines.items[j].lineprice)).toFixed(2)

        //             let sign = Math.sign(this.sllines.items[j].qty)
        //             let price = parseFloat(Math.abs(this.sllines.items[j].lineprice))
        //             let tax = parseFloat(Math.abs(this.sllines.items[j].linetaxes))
        //             let qty = Math.abs(this.sllines.items[j].qty)
        //             this.sllines.items[j].linesubtotal = (((price + tax) * qty) * sign).toFixed(2);

        //             if (isNaN(this.sllines.items[j].linevat)) { this.sllines.items[j].linevat = "0" }
        //             this.sllines.items[j].linevat = parseFloat(this.sllines.items[j].linevat).toFixed(2)
        //             this.sllines.items[j].linetotal = (parseFloat(this.sllines.items[j].linesubtotal) + parseFloat(this.sllines.items[j].linefees) + parseFloat(this.sllines.items[j].linevat)).toFixed(2);

        //             this.amount += parseFloat(this.sllines.items[j].linetotal)

        //         }
        //     }
        //     this.markup_saletotal = this.amount.toFixed(2)
        //     if (this.item.outstanding = this.item.saletotal) {
        //         this.due = this.markup_saletotal
        //     }
        // },
    },
};
</script>